var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInicio2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.476,
    height: 129.316,
    viewBox: "0 0 122.476 129.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b,.c{fill:#fff;}.c{font-size:14px;font-family:VWHead-BoldItalic, VW Head;font-weight:700;font-style:italic;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-589.991 -928)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(589.991 950.981)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(9.741 44.953)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M334.559,716.107h13.432c15.132,0,20.411,7.04,20.411,19.943s-5.28,19.943-20.411,19.943H334.559Zm12.669,31.849c9.031,0,10.851-3.812,10.851-11.906s-1.82-11.906-10.851-11.906h-2.7v23.813Z",
    transform: "translate(-334.559 -716.107)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M380.3,716.107v8.037H369.33v31.85h-9.97v-31.85H348.45v-8.037Z",
    transform: "translate(-311.907 -716.107)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(92.621 55.689)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M380.964,750.217c-9.678,0-14.9-6.8-14.9-15.013s5.222-15.016,14.9-15.016c9.852,0,14.955,6.8,14.955,15.016S390.816,750.217,380.964,750.217Zm0-6.508c4.164,0,6.861-2.818,6.861-8.505s-2.7-8.508-6.861-8.508c-4.049,0-6.806,2.818-6.806,8.508S376.916,743.709,380.964,743.709Z",
    transform: "translate(-366.064 -720.188)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(9.77 19.909)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M348.665,706.983l-6.2,16.129h-1.694l-6.2-16.129v-.2h1.66l5.353,14.263h.068l5.353-14.263h1.66Z",
    transform: "translate(-334.57 -706.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M365.859,706.983l-5.864,16.129H358.3l-5.014-14.3h-.068l-5.014,14.3H346.51l-5.861-16.129v-.2h1.626l5.048,14.061h.068l5.014-14.061H354.1l5.014,14.061h.068l5.048-14.061h1.628Z",
    transform: "translate(-324.657 -706.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M352.973,707.1l.168,1.457h.069a9.369,9.369,0,0,1,5.59-1.965c2.3,0,3.93.813,4.746,2.168h.066a9.787,9.787,0,0,1,6.135-2.168c3.964,0,5.724,2.2,5.724,6.437v10.4h-1.626V713.3c0-3.525-1.186-5.185-4.235-5.185a8.892,8.892,0,0,0-5.522,2.034,13.018,13.018,0,0,1,.305,2.881v10.4h-1.628V713.3c0-3.117-.542-5.185-4.1-5.185a8.407,8.407,0,0,0-5.353,2v13.316h-1.626V707.1Z",
    transform: "translate(-306.658 -706.587)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M410.868,805.354H339.09a8.243,8.243,0,0,1-8.234-8.234V707.253a8.243,8.243,0,0,1,8.234-8.234h71.778a8.243,8.243,0,0,1,8.237,8.234V797.12A8.244,8.244,0,0,1,410.868,805.354ZM339.09,702a5.254,5.254,0,0,0-5.248,5.248V797.12a5.254,5.254,0,0,0,5.248,5.248h71.778a5.255,5.255,0,0,0,5.251-5.248V707.253A5.255,5.255,0,0,0,410.868,702Z",
    transform: "translate(-330.856 -699.019)"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "c",
    transform: "translate(590.237 942)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Digitalized by")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInicio2);
export default __webpack_public_path__ + "static/media/inicio2.cb86155aa2b17661f7c235bca5503a8a.svg";
export { ForwardRef as ReactComponent };